import { t } from "../../i18n";
import { Hash } from "lucide-react";
import { asRecord, stringValue } from "./ToolResultView.utils";
import { GenericResult } from "./GenericResult";

export function CalculateResult({ result }: { result: unknown }) {
  const values = asRecord(result);
  if (!values) return <GenericResult value={result} />;
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50/70 p-3 dark:border-sky-900/60 dark:bg-sky-950/20">
      <div className="flex items-center gap-2 text-xs font-semibold text-sky-800 dark:text-sky-200">
        <Hash size={14} /> {t("Calculation complete")}
      </div>
      <div className="mt-2 flex flex-wrap items-end gap-x-3 gap-y-1">
        <code className="max-w-full rounded-lg bg-white/80 px-2 py-1.5 font-mono text-xs break-words text-stone-600 dark:bg-black/20 dark:text-stone-300">
          {stringValue(values.expression) || "Expression"}
        </code>
        <span className="text-lg font-bold text-sky-700 dark:text-sky-300">
          =
        </span>
        <span className="text-2xl font-bold tracking-tight text-stone-900 dark:text-white">
          {typeof values.result === "number"
            ? values.result.toLocaleString()
            : String(values.result ?? "—")}
        </span>
      </div>
    </div>
  );
}
